const layers = [
    {
        'id': 'Adasis/Route',
        'source': 'Adasis',
        'type': 'line',
        'filter': ['==', '$type', 'LineString'],
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        
        'paint': {
            'line-color': '#566171',
            'line-width': 4
        }
    },
    {
        'id': 'mpp/Edges',
        'source': 'mpp',
        'type': 'line',
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        'filter': ['==', '$type', 'LineString'],
        'paint': {
            'line-color': '#98CAFF',
            'line-width': 3
        }
    },
    {
        'id': 'Adasis/Messages',
        'source': 'Adasis',
        'type': 'circle',
        'filter': ['==', '$type', 'Point'],
        'paint': {
            'circle-radius': [
                'case',
                ['==', ['get', 'type'], 'STUB'],
                6,
                ['==', ['get', 'type'], 'SEGMENT'],
                5,
                ['==', ['get', 'type'], 'PROFILE SHORT'],
                4,
                ['==', ['get', 'type'], 'PROFILE LONG'],
                3,
                ['==', ['get', 'type'], 'POSITION'],
                7,
                1
            ],
            'circle-color': [
                'case',
                ['==', ['get', 'type'], 'STUB'],
                '#FEDE4E',
                ['==', ['get', 'type'], 'SEGMENT'],
                '#FF9B31',
                ['==', ['get', 'type'], 'PROFILE SHORT'],
                '#F45B47',
                ['==', ['get', 'type'], 'PROFILE LONG'],
                '#2FC078',
                ['==', ['get', 'type'], 'POSITION'],
                '#007AFC',
                'black'
            ]
        }
    }
];

export default layers;